var map = {
	"./template.bet575": 1700,
	"./template.bet575.tsx": 1700,
	"./template.bet777": 1701,
	"./template.bet777.tsx": 1701,
	"./template.betgalaxy": 1702,
	"./template.betgalaxy.tsx": 1702,
	"./template.betprofessor": 2153,
	"./template.betprofessor.tsx": 2153,
	"./template.betroyale": 1703,
	"./template.betroyale.tsx": 1703,
	"./template.betstride": 1704,
	"./template.betstride.tsx": 1704,
	"./template.chromabet": 1705,
	"./template.chromabet.tsx": 1705,
	"./template.default": 678,
	"./template.default.tsx": 678,
	"./template.epicodds": 1706,
	"./template.epicodds.tsx": 1706,
	"./template.fiestabet": 2154,
	"./template.fiestabet.tsx": 2154,
	"./template.forsport": 1707,
	"./template.forsport.tsx": 1707,
	"./template.gigabet": 2155,
	"./template.gigabet.tsx": 2155,
	"./template.goldenbet888": 2156,
	"./template.goldenbet888.tsx": 2156,
	"./template.goldenrush": 2157,
	"./template.goldenrush.tsx": 2157,
	"./template.hyperbet": 2158,
	"./template.hyperbet.tsx": 2158,
	"./template.juicybet": 1708,
	"./template.juicybet.tsx": 1708,
	"./template.junglebet": 1709,
	"./template.junglebet.tsx": 1709,
	"./template.magnumbet": 1710,
	"./template.magnumbet.tsx": 1710,
	"./template.oldgill": 2159,
	"./template.oldgill.tsx": 2159,
	"./template.puntcity": 1711,
	"./template.puntcity.tsx": 1711,
	"./template.puntgenie": 1712,
	"./template.puntgenie.tsx": 1712,
	"./template.pyramidbet": 1713,
	"./template.pyramidbet.tsx": 1713,
	"./template.questbet": 2160,
	"./template.questbet.tsx": 2160,
	"./template.slambet": 2161,
	"./template.slambet.tsx": 2161,
	"./template.sterlingparker": 2162,
	"./template.sterlingparker.tsx": 2162,
	"./template.sugarcastle": 1714,
	"./template.sugarcastle.tsx": 1714,
	"./template.templebet": 1715,
	"./template.templebet.tsx": 1715,
	"./template.titanbet": 2163,
	"./template.titanbet.tsx": 2163,
	"./template.ts": 991,
	"./template.vikingbet": 1716,
	"./template.vikingbet.tsx": 1716,
	"./template.volcanobet": 1717,
	"./template.volcanobet.tsx": 1717,
	"./template.wellbet": 2164,
	"./template.wellbet.tsx": 2164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2475;